import React, { PropsWithChildren } from 'react';

import { FormGroupContainer } from './style';

const FormGroup: React.FC<PropsWithChildren> = ({ children }) => {
  return <FormGroupContainer>{children}</FormGroupContainer>;
};

export default FormGroup;
